export class SharedActionKey {
  static readonly TO_PDF = 'shared/action/to-pdf';
  static readonly TO_CSV = 'shared/action/to-csv';
}
